import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { SizeRecord } from "../../helper/SizeRecord";

export const TextSizeRecord = Record({
  text: null,
  size: SizeRecord()
});

const data = {
  objects: {
    size: "SizeRecord"
  }
};
createFromJS.registerCallback("TextSizeRecord", createFromJS.createNestedCallback(TextSizeRecord, data));
